var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('veui-icon',{class:_vm.klass,attrs:{"ui":_vm.ui},nativeOn:{"click":function($event){return _vm.sort($event)}}},[_c('veui-icon',{class:{
      'veui-sorter-icon-asc': true,
      'veui-sorter-active': _vm.order === 'asc',
      'veui-sorter-inactive': _vm.order === 'desc'
    },attrs:{"name":_vm.icons.asc}}),_c('veui-icon',{class:{
      'veui-sorter-icon-desc': true,
      'veui-sorter-active': _vm.order === 'desc',
      'veui-sorter-inactive': _vm.order === 'asc'
    },attrs:{"name":_vm.icons.desc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }